import { render, staticRenderFns } from "./cards_bak.vue?vue&type=template&id=618daee6&scoped=true"
import script from "./cards_bak.vue?vue&type=script&lang=js"
export * from "./cards_bak.vue?vue&type=script&lang=js"
import style0 from "./cards_bak.vue?vue&type=style&index=0&id=618daee6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618daee6",
  null
  
)

export default component.exports